if (!customElements.get('most-searched-container')) {
  customElements.define(
    'most-searched-container',
    class mostSearchedContainer extends HTMLElement {
      constructor() {
        super();
        this.mostSearchedKey = this.dataset.mostSearchedKey || '';
        this.url = `/search?type=product&q=${this.mostSearchedKey.trim()}&section_id=most-searched`;
        this._fetched = false;
      }

      connectedCallback() {
        if (this.totalItems > 1) {
          this.startRotation();
          this.setupEventListeners();
        }
        this.fetchData();
      }

      startRotation() {}

      get totalItems() {
        return this.querySelectorAll('.most-searched-item').length;
      }

      fetchData() {
        if (this._fetched) return;
        this._fetched = true;
        fetch(this.url)
          .then((response) => response.text())
          .then((data) => {
            this.innerHTML = data;
            if (this.totalItems > 1) {
              this.startRotation();
              this.setupEventListeners();
            }
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
            this._fetched = false;
          });
      }

      loadContent() {
        this.fetchData();
      }
    }
  );
}

document.querySelector('#search-button--mobile').addEventListener('click', () => {
  document.querySelector('[data-header-search-open]').click();
});
